"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _SessionHandler = _interopRequireDefault(require("../../../../../utils/SessionHandler"));
var NoRegisterError = function NoRegisterError(props) {
  _SessionHandler.default.destroySession(false);
  var arrowLeftIcon = /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("title", null, "E9B900B7-E313-43AA-B8A9-8918D6852A02"), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.874 15L6 14.126 11.126 9 6 3.874 6.874 3l6 6-6 6"
  })));
  var showRegistrationAndLogoutButtons = props.registrationButtonTxt && props.registrationButtonLink && props.logoutAndCloseButtonTxt && props.logoutAndCloseButtonLink;
  var pathDescription = 'M27 14.003c-1.103 0-2 .897-2 2s.897 ' + '2 2 2 2-.897 2-2-.897-2-2-2zm0 5c-1.654 0-3-1.346-3-3s1.346-3 ' + '3-3 3 1.346 3 3-1.346 3-3 3zm-2 23h4v-19h-4v19zm4.5 1h-5a.5.5 0 ' + '0 1-.5-.5v-20a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v20a.5.5 0 0 ' + '1-.5.5zm-2.5-42c-14.337 0-26 11.664-26 26 0 14.337 11.663 26 26 ' + '26s26-11.663 26-26c0-14.336-11.663-26-26-26zm0 53c-14.888 ' + '0-27-12.112-27-27s12.112-27 27-27 27 12.112 27 27-12.112 27-27 27z';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "no-meter-error-container row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "svg-bckgrd"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "no-meter-error-container__exclamation",
    width: "54",
    height: "55",
    viewBox: "0 0 54 55",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("title", null, "6758B6DD-5E7D-456D-B810-9212FE77B926"), /*#__PURE__*/_react.default.createElement("path", {
    d: pathDescription,
    fill: "#000",
    fillRule: "evenodd"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "no-meter-error-container__flex-center-vertically"
  }, props.isSmallText ? /*#__PURE__*/_react.default.createElement("p", {
    className: "no-meter-error-container__label"
  }, props.noRegisterError) : /*#__PURE__*/_react.default.createElement("h4", {
    className: "no-meter-error-container__label"
  }, props.noRegisterError), showRegistrationAndLogoutButtons && /*#__PURE__*/_react.default.createElement("div", {
    className: "button-group centered"
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.StandardLink, {
    className: "button button--v0",
    href: props.registrationButtonLink,
    onClick: function onClick() {
      return _SessionHandler.default.destroySession(true, props.registrationButtonLink, function () {});
    },
    linkText: props.registrationButtonTxt
  }), /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.StandardLink, {
    className: "button button--v0",
    href: props.logoutAndCloseButtonLink,
    onClick: function onClick() {
      return _SessionHandler.default.destroySession(true, props.logoutAndCloseButtonLink, function () {});
    },
    linkText: props.logoutAndCloseButtonTxt
  })), props.anonymousMeterReadingLoginPage && props.logoutButtonTxt && !showRegistrationAndLogoutButtons && /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.StandardLink, {
    className: "no-meter-error-container__enter-another-meter-reading",
    iconLeft: arrowLeftIcon,
    href: props.anonymousMeterReadingLoginPage,
    onClick: function onClick() {
      return _SessionHandler.default.destroySession(true, props.anonymousMeterReadingLoginPage, function () {});
    },
    linkText: props.logoutButtonTxt
  })));
};
var _default = exports.default = NoRegisterError;